(() => {
  const SELECTOR = '.estimated-delivery-dates';

  /**
   * Lägger till arbetsdagar och hoppar över lördag och söndag.
   *
   * Exempel:
   * fredag + 1 arbetsdag = måndag
   */
  function addBusinessDays(startDate, numberOfDays) {
    const date = new Date(startDate);
    let addedDays = 0;

    date.setHours(12, 0, 0, 0);

    while (addedDays < numberOfDays) {
      date.setDate(date.getDate() + 1);

      const weekday = date.getDay();
      const isWeekend = weekday === 0 || weekday === 6;

      if (!isWeekend) {
        addedDays += 1;
      }
    }

    return date;
  }

  /**
   * Sverige: 1–3 arbetsdagar.
   * Övriga marknader: 1–5 arbetsdagar.
   */
  function getDeliveryRange(domain) {
    const normalizedDomain = domain
      .toLowerCase()
      .replace(/^www\./, '');

    if (normalizedDomain === 'koreanbeauty.se') {
      return {
        minimumDays: 1,
        maximumDays: 3
      };
    }

    return {
      minimumDays: 1,
      maximumDays: 5
    };
  }

  function getLocale(localeCode) {
    const languageCode = localeCode
      .toLowerCase()
      .split('-')[0];

    const locales = {
      sv: 'sv-SE',
      da: 'da-DK',
      de: 'de-DE',
      en: 'en-GB',
      es: 'es-ES',
      fi: 'fi-FI',
      fr: 'fr-FR',
      nl: 'nl-NL',
      no: 'nb-NO',
      nb: 'nb-NO',
      nn: 'nn-NO',
      pl: 'pl-PL',
      pt: 'pt-PT',
      it: 'it-IT',
      el: 'el-GR',
      sk: 'sk-SK',
      sl: 'sl-SI',
      tr: 'tr-TR'
    };

    return locales[languageCode] || 'en-GB';
  }

  function formatDeliveryRange(fromDate, toDate, locale) {
    const fromMonth = fromDate.getMonth();
    const toMonth = toDate.getMonth();
    const sameMonth = fromMonth === toMonth;

    /*
     * När båda datumen är i samma månad:
     * 15–17 juli
     *
     * När datumen ligger i olika månader:
     * 30 juli–3 augusti
     */
    if (sameMonth) {
      const fromDay = new Intl.DateTimeFormat(locale, {
        day: 'numeric'
      }).format(fromDate);

      const toDateFormatted = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'long'
      }).format(toDate);

      return `${fromDay}–${toDateFormatted}`;
    }

    const formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'long'
    });

    return `${formatter.format(fromDate)}–${formatter.format(toDate)}`;
  }

  function updateEstimatedDelivery(container = document) {
    const elements = container.querySelectorAll(SELECTOR);

    elements.forEach((element) => {
      const domain = element.dataset.domain || window.location.hostname;
      const locale = getLocale(
        element.dataset.locale ||
        document.documentElement.lang ||
        'en'
      );

      const range = getDeliveryRange(domain);
      const today = new Date();

      const earliestDate = addBusinessDays(
        today,
        range.minimumDays
      );

      const latestDate = addBusinessDays(
        today,
        range.maximumDays
      );

      element.textContent = formatDeliveryRange(
        earliestDate,
        latestDate,
        locale
      );

      element.dataset.deliveryInitialized = 'true';
    });
  }

  function initializeEstimatedDelivery() {
    updateEstimatedDelivery(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeEstimatedDelivery
    );
  } else {
    initializeEstimatedDelivery();
  }

  /*
   * Kör om funktionen när Shopify uppdaterar eller byter sektion
   * i temaredigeraren.
   */
  document.addEventListener('shopify:section:load', (event) => {
    updateEstimatedDelivery(event.target);
  });
})();